import React from 'react';
import PageContent from './PageContent';

const PrivacyPolicy = () => {
  return <PageContent tag='PRIVACY_POLICY_WD' id='5e1edb1229f787cb8a9eed36'/>;
}

export default PrivacyPolicy;